// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signUpMargin {
  margin: 15px;
}

@media (max-width: 479px) {
  .signUpMargin {
    margin: 15px 0px;
  }
}

@media (max-width: 390px) {
  .logoCustom {
    width: 154px;
  }
  .signUpMargin {
    margin: 15px 0px;
  }
}

@media (min-width: 390px) {
  .logoCustom {
    width: 210px;
  }
}

@media (max-width: 404px) {
  .customSignINcom {
    display: none;
  }
  .customSignINhalf {
    display: block;
  }
}

@media (max-width: 479px) {
  .signUpButton {
    display: block;
    margin-top: 15px 0px;
  }
}

@media (min-width: 479px) {
  .signUpButton {
    display: none;
  }
}

@media (min-width: 404px) {
  .customSignINcom {
    display: block;
  }
  .customSignINhalf {
    display: none;
  }
}

.top-bar {
  background-color: #f7b634 !important;
}
.top-bar-item {
  margin-left: 25px !important;
}
.top-bar-item a.text-white.small-text {
  font-size: 18px;
}
.main-container {
  max-width: 1600px !important;
}
.navbar-wrapper.sticky-top {
  box-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.04);
}
a.nav-button.w-button {
  color: #000000;
  font-size: 15px !important;
  padding: 0px 15px 0px 15px;
}
a.nav-button.w-button:hover {
  color: #2ecbd3;
}
a.button.small.w-inline-block {
  padding: 10px 15px 10px 15px !important;
  width: auto !important;
  font-size: 18px !important;
  font-weight: 700;
  color: #fff;
  border-radius: 5px !important;
  background-color: #2ecbd3;
  margin: 0 !important;
}
.signUpMargin {
  margin: 0 15px 0 0 !important;
}
a.button.small.w-inline-block.w--current.linebutton {
  background-color: #fff !important;
  border: 1px solid #2ecbd3;
  color: #2ecbd3;
}

.aux-text {
  font-size: 15px !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/Header.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;IACd,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".signUpMargin {\n  margin: 15px;\n}\n\n@media (max-width: 479px) {\n  .signUpMargin {\n    margin: 15px 0px;\n  }\n}\n\n@media (max-width: 390px) {\n  .logoCustom {\n    width: 154px;\n  }\n  .signUpMargin {\n    margin: 15px 0px;\n  }\n}\n\n@media (min-width: 390px) {\n  .logoCustom {\n    width: 210px;\n  }\n}\n\n@media (max-width: 404px) {\n  .customSignINcom {\n    display: none;\n  }\n  .customSignINhalf {\n    display: block;\n  }\n}\n\n@media (max-width: 479px) {\n  .signUpButton {\n    display: block;\n    margin-top: 15px 0px;\n  }\n}\n\n@media (min-width: 479px) {\n  .signUpButton {\n    display: none;\n  }\n}\n\n@media (min-width: 404px) {\n  .customSignINcom {\n    display: block;\n  }\n  .customSignINhalf {\n    display: none;\n  }\n}\n\n.top-bar {\n  background-color: #f7b634 !important;\n}\n.top-bar-item {\n  margin-left: 25px !important;\n}\n.top-bar-item a.text-white.small-text {\n  font-size: 18px;\n}\n.main-container {\n  max-width: 1600px !important;\n}\n.navbar-wrapper.sticky-top {\n  box-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.04);\n}\na.nav-button.w-button {\n  color: #000000;\n  font-size: 15px !important;\n  padding: 0px 15px 0px 15px;\n}\na.nav-button.w-button:hover {\n  color: #2ecbd3;\n}\na.button.small.w-inline-block {\n  padding: 10px 15px 10px 15px !important;\n  width: auto !important;\n  font-size: 18px !important;\n  font-weight: 700;\n  color: #fff;\n  border-radius: 5px !important;\n  background-color: #2ecbd3;\n  margin: 0 !important;\n}\n.signUpMargin {\n  margin: 0 15px 0 0 !important;\n}\na.button.small.w-inline-block.w--current.linebutton {\n  background-color: #fff !important;\n  border: 1px solid #2ecbd3;\n  color: #2ecbd3;\n}\n\n.aux-text {\n  font-size: 15px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
